import React from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router';
import { routes } from '@/constant/routes.const';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { IMG_LOGO_KTP_BLUE, IMG_LOGO_KTP_WHITE } from '@repo/assets';
import { isRefundableAirport } from '@repo/utils';

interface IProps {
  isTop: boolean;
  isMobile?: boolean;
}
function Logo({ isTop, isMobile }: IProps) {
  const {
    departureDate,
    passportNumber,
    existDirectRefund,
    email,
    isAirportRefundable,
  } = useAppSelector((state) => state) as IGlobalState;
  const { pathname } = useLocation();
  const history = useHistory();

  const onClick = () => {
    if (
      pathname === '/select-airport' ||
      pathname === '/airport-non-refundable' ||
      pathname.includes('/inquiry')
    ) {
      return;
    }

    if (isAirportRefundable) {
      const isTransferWeb = localStorage.getItem(`${passportNumber}-transfer`);
      if (isTransferWeb === 'true') {
        if (departureDate) {
          history.replace(routes.medicalHome);
        } else {
          history.replace(routes.medicalDeparture);
        }
        return;
      }

      if (
        isRefundableAirport(
          passportNumber && localStorage.getItem(passportNumber),
        )
      ) {
        history.replace(routes.medicalAirport);
        return;
      }
      if (passportNumber && !!localStorage.getItem(passportNumber)) {
        if (departureDate) {
          history.replace(routes.medicalHome);
        } else {
          history.replace(routes.medicalDeparture);
        }
        return;
      }

      history.replace(routes.medicalSelectAirport);
      return;
    }

    if (!email) return;
    // 처음 화면
    if (pathname === '/') {
      return;
    }

    if (pathname === '/refund-info-leaflet') {
      history.push(routes.medical);
      return;
    }

    if (!existDirectRefund) {
      //차감결제
      history.replace(routes.medicalReceipt);
      return;
    } //전액결제

    if (departureDate) {
      history.replace(routes.medicalHome);
    } else {
      history.replace(routes.medicalDeparture);
    }
    return;
  };
  return (
    <LogoWrapper isMobile={isMobile}>
      <SLogo
        alt='Korea Tax Free Payments'
        src={isTop ? IMG_LOGO_KTP_WHITE : IMG_LOGO_KTP_BLUE}
        onClick={onClick}
      />
    </LogoWrapper>
  );
}

const LogoWrapper = styled.div<{ isMobile?: boolean }>`
  position: relative;
  width: 80px;
  height: 22px;
`;

const SLogo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;
export default Logo;
